import reducer from "./reducer";
export { default as clockReducerName } from "./constants";
export default reducer;

